export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.9cdfcb16.png";